// @format
import { compose, replace } from 'ramda';

export const extractPrice = compose(replace(/[^\d.-]/g, ''));
